import { useSelector } from 'react-redux';

import { RootState } from 'store';

import {
  checkIsLoading,
  checkIsLoadingDone,
  checkIsLoadingError
} from 'common/utils/checkLoading';

import {
  MAP_STATE,
  MAP_NAMES,
  COST_TYPES
} from '../../constants';

export const useInitializedMap = () => {
  const initializingMap = useSelector((state: RootState) => state[MAP_STATE].initialized);
  return initializingMap;
};

export const useFocusPoint = () => {
  const focusPoint = useSelector((state: RootState) => state[MAP_STATE].focusPoint);
  return focusPoint;
};

export const useRoutesFilter = () => {
  const routesFilter = useSelector((state: RootState) => state[MAP_STATE].routes.filter);
  return routesFilter;
};

export const useShowStreetView = () => {
  const showStreetView = useSelector((state: RootState) => state[MAP_STATE].showStreetView);
  return showStreetView;
};

export const useSelectedPoint = () => {
  const selectedPoint = useSelector((state: RootState) => state[MAP_STATE].selectedPoint);
  return selectedPoint;
};

export const useMapName = () => (
  useSelector((state: RootState) => state[MAP_STATE].name)
);

export const useIsActiveGoogleMap = () => {
  const mapName = useMapName();

  return mapName === MAP_NAMES.google;
};

export const useIsActiveHereMap = () => {
  const mapName = useMapName();

  return mapName === MAP_NAMES.here;
};

export const usePlannedRoutesPlanId = () => (
  useSelector((state: RootState) => state[MAP_STATE].routes.planId)
);

export const usePlannedRoutes = () => (
  useSelector((state: RootState) => state[MAP_STATE].routes.plannedRoutes)
);

export const useRouteStations = () => (
  useSelector((state: RootState) => state[MAP_STATE].routes.routeStations)
);

export const useRoutePrices = () => (
  useSelector((state: RootState) => state[MAP_STATE].routes.routePrices)
);

export const useStationServicePrices = () => (
  useSelector((state: RootState) => state[MAP_STATE].routes.stationServicePrices)
);

export const usePlannedRouteActiveCostType = () => (
  useSelector((state: RootState) => state[MAP_STATE].routes.activeCostType)
);

export const useIsPlannedRouteActiveNettoCostType = () => (
  usePlannedRouteActiveCostType() === COST_TYPES.netto
);

export const useIsPlannedRouteActiveBruttoCostType = () => (
  usePlannedRouteActiveCostType() === COST_TYPES.brutto
);

export const usePlannedRouteActiveExcise = () => (
  useSelector((state: RootState) => state[MAP_STATE].routes.activeExcise)
);

export const usePlannedRoutesLoadingStatus = () => (
  useSelector((state: RootState) => state[MAP_STATE].routes.plannedRoutesLoadingStatus)
);

export const useIsPlannedRoutesLoading = () => checkIsLoading(usePlannedRoutesLoadingStatus());
export const useIsPlannedRoutesDone = () => checkIsLoadingDone(usePlannedRoutesLoadingStatus());
export const useIsPlannedRoutesError = () => checkIsLoadingError(usePlannedRoutesLoadingStatus());

export const useRouteStationsLoadingStatus = () => (
  useSelector((state: RootState) => state[MAP_STATE].routes.routeStationsLoadingStatus)
);

export const useIsRouteStationsLoading = () => checkIsLoading(useRouteStationsLoadingStatus());
export const useIsRouteStationsDone = () => checkIsLoadingDone(useRouteStationsLoadingStatus());
export const useIsRouteStationsError = () => checkIsLoadingError(useRouteStationsLoadingStatus());

export const useRoutePricesLoadingStatus = () => (
  useSelector((state: RootState) => state[MAP_STATE].routes.routePricesLoadingStatus)
);

export const useIsRoutePricesLoading = () => checkIsLoading(useRoutePricesLoadingStatus());
export const useIsRoutePricesDone = () => checkIsLoadingDone(useRoutePricesLoadingStatus());
export const useIsRoutePricesError = () => checkIsLoadingError(useRoutePricesLoadingStatus());
